import { attempt } from '@immutabl3/utils';
import useAssets from './useAssets';
import {
  useEffect,
  createContext,
  useContext as useReactContext,
} from 'react';

const Context = createContext({ value: undefined });
const { Provider } = Context;

export const AssetContext = function({ keys, children }) {
  const assets = useAssets(keys);
  return (
    <Provider value={ { value: assets } }>
      { children }
    </Provider>
  );
};

const useVideoState = function(asset) {
  useEffect(() => {
    if (!asset.isVideoTexture) return;

    const video = asset.source.data;
    attempt(() => video.play());

    return () => {
      attempt(() => video.pause());
    };
  }, []);
};

export const useAsset = function(key) {
  const asset = useReactContext(Context).value[key];
  useVideoState(asset);
  return asset;
};
